window.WEBPACK_SUPPORTED_LOCALES = ["es","en"];
window.WEBPACK_NATIVE_LOCALE = 'es';